import { SDSFlexbox } from '@repo/sds/SDSFlexbox';

import type { Country } from '../../constants/countries';
import { COUNTRIES, countryCallingCode } from '../../constants/countries';
import { CountryListItem } from '../CountryListItem/CountryListItem';

import './CountryList.scss';

interface CountryListProps {
  search: string;
  onSelectCountry: (country: Country) => void;
  selectedCountry?: string;
  showFlag?: boolean;
}

export function CountryList({ search, onSelectCountry, selectedCountry, showFlag = true }: CountryListProps) {
  const searchLower = search.toLowerCase();
  const filteredCountries = search
    ? COUNTRIES.filter(
        country =>
          country.name.toLowerCase().includes(searchLower) ||
          country.code.toLowerCase().includes(searchLower) ||
          countryCallingCode(country.code).includes(search),
      )
    : COUNTRIES;

  return (
    <SDSFlexbox direction="column" className="CountryList">
      {filteredCountries.length > 0 ? (
        filteredCountries.map(country => (
          <CountryListItem
            key={country.code}
            country={country}
            onClick={onSelectCountry}
            isSelected={selectedCountry === country.code}
            showFlag={showFlag}
          />
        ))
      ) : (
        <div className="CountryList__empty">No countries found</div>
      )}
    </SDSFlexbox>
  );
}
